import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Teleport as _Teleport, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "add-comment-box"
};
var _hoisted_2 = {
  class: "comment-body"
};
var _hoisted_3 = {
  class: "add-comment-body"
};
var _hoisted_4 = {
  class: "add-comment__head"
};
var _hoisted_5 = {
  class: "list"
};
var _hoisted_6 = ["onClick"];
import { ref, computed, onMounted, nextTick } from 'vue';
import { isNullValue } from '../utils';
import { CheckIcon, CloseIcon } from 'tdesign-icons-vue-next';
import { MessagePlugin } from 'tdesign-vue-next';
import { addComments, deleteComments, getQueryComments } from '@/api/evaluate.js';
export default {
  __name: 'AddComment',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['add', 'close'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var content = ref('');
    var commentData = ref([]);
    var disabled = computed(function () {
      return commentData.value.length >= 20;
    });
    var visible = ref(false);
    onMounted(function () {});
    var initComments = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var targetId, res, data, tempData, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              targetId = props.data.targetId;
              if (!isNullValue(targetId)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return getQueryComments(targetId);
            case 2:
              res = _context.v;
              data = res.data.data;
              tempData = data || [];
              commentData.value = tempData.reverse();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              _t.message && MessagePlugin.error(_t.message || '操作失败，请重试');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function initComments() {
        return _ref2.apply(this, arguments);
      };
    }();
    var commentListEl = function commentListEl() {
      var el = document.querySelector('.add-comment-box');
      var commentBody = document.querySelector('.add-comment-body');
      var rect = el.getBoundingClientRect();
      commentBody.style.top = rect.bottom + 8 + 'px';
      commentBody.style.right = '24px';
    };
    /**
     * 打开
     */
    var changeSlotEvent = function changeSlotEvent() {
      visible.value = !visible.value;
      if (visible.value) {
        initComments();
        nextTick(function () {
          commentListEl();
        });
      } else {
        commentData.value = [];
      }
    };
    /**
     * 添加评价
     */
    var clickSaveEvent = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _props$data, targetId, projectId, item, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!isNullValue(content.value)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, MessagePlugin.error('请输入文字！'));
            case 1:
              _props$data = props.data, targetId = _props$data.targetId, projectId = _props$data.projectId;
              item = {
                targetId: targetId,
                projectId: projectId,
                content: content.value
              };
              _context2.p = 2;
              _context2.n = 3;
              return addComments(item);
            case 3:
              initComments();
              content.value = '';
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              _t2.message && MessagePlugin.error(_t2.message || '操作失败，请重试');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2, 4]]);
      }));
      return function clickSaveEvent() {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * 关闭
     */
    var closeEvent = function closeEvent() {
      emit('close');
    };
    /**
     * 删除评语
     */
    var deleteCommentEvent = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(item) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return deleteComments(item.id);
            case 1:
              commentData.value = commentData.value.filter(function (cItem) {
                return cItem.id !== item.id;
              });
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              _t3.message && MessagePlugin.error(_t3.message || '操作失败，请重试');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return function deleteCommentEvent(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    /**
     * 选择评语
     */
    var changeComment = function changeComment(item) {
      changeSlotEvent();
      emit('add', item);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_input = _resolveComponent("t-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        onClick: changeSlotEvent
      }, [_renderSlot(_ctx.$slots, "default")]), visible.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [_createElementVNode("div", _hoisted_2, [visible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "add-comment-bg",
        onClick: changeSlotEvent
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "快捷评语", -1)), _createVNode(_component_svg_icon, {
        name: "close",
        onClick: closeEvent
      })]), _createVNode(_component_t_input, {
        value: content.value,
        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
          return content.value = $event;
        }),
        maxlength: 20,
        disabled: disabled.value,
        placeholder: "添加新评语"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "input-right",
            onClick: _withModifiers(clickSaveEvent, ["stop"])
          }, [_createVNode(_unref(CheckIcon), {
            style: {
              "color": "rgb(35 42 53 / 40%)"
            }
          })])];
        }),
        _: 1
      }, 8, ["value", "disabled"]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentData.value, function (commentItem) {
        return _openBlock(), _createElementBlock("div", {
          key: commentItem.id,
          class: "list-item"
        }, [_createElementVNode("span", {
          class: "item-content",
          onClick: function onClick($event) {
            return changeComment(commentItem);
          }
        }, _toDisplayString(commentItem.content), 9, _hoisted_6), _createVNode(_unref(CloseIcon), {
          style: {
            "color": "rgb(35 42 53 / 40%)",
            "cursor": "pointer"
          },
          onClick: function onClick($event) {
            return deleteCommentEvent(commentItem);
          }
        }, null, 8, ["onClick"])]);
      }), 128))])])])])) : _createCommentVNode("", true)]);
    };
  }
};